import SaveIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";

const CustomControlEditTextField = (props: any) => {
  const {
    name,
    value,
    defaultValue,
    onChange,
    onBlur,
    required,
    helperText,
    className,
    showAction = true,
  } = props;
  const [error, setError] = useState(false);
  const [readOnly, setReadOnly] = useState(true);
  const [values, setValues] = React.useState(
    value !== undefined && value !== null
      ? value.toString()
      : defaultValue?.toString() || ""
  );

  React.useEffect(() => {
    if (value !== undefined && value !== null) {
      setValues(value.toString());
      return;
    }

    setValues(defaultValue?.toString() || "");
  }, [value, defaultValue]);

  const handleEdit = () => {
    setReadOnly(false);
  };
  const handleSaveEdit = () => {
    setReadOnly(true);
  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues(event.target.value);
    if (onChange) {
      onChange(event);
    }
  };
  const handleBlur = (event: any) => {
    if (required) {
      if (values == "") {
        setError(true);
      } else {
        setError(false);
      }
    } else {
      setError(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };
  let helperTextValue = helperText?.toString() || "This field is required";
  if (helperText === "no") {
    helperTextValue = "";
  }
  return (
    <TextField
      id={name}
      name={name}
      required={required}
      error={error}
      helperText={error ? helperTextValue : ""}
      variant="outlined"
      // defaultValue={defaultValue}
      value={values}
      onChange={handleChange}
      onBlur={handleBlur}
      className={className}
      sx={{
        // "& input[readonly]": { background: "#e5e5e5" },
        "& .MuiInputBase-readOnly": {
          background: "#e5e5e5",
          borderRadius: "10px",
        },
        "& input": { pl: "14px", pt: "5px" },
      }}
      InputProps={{
        readOnly: readOnly,
        endAdornment: showAction ? (
          <InputAdornment position="end">
            <IconButton
              onClick={readOnly ? handleEdit : handleSaveEdit}
              edge="end"
            >
              {readOnly ? (
                <EditIcon sx={{ fontSize: "16px", color: "#1976d2" }} />
              ) : (
                <SaveIcon sx={{ fontSize: "16px", color: "#1976d2" }} />
              )}
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

export default CustomControlEditTextField;
